import { Entry } from '../Entry'

export function Entry20240418() {
  return (
    <Entry title="Apr 18 2024 - v3.6.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15820/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
